import React, { Component } from "react";
import { css } from "aphrodite/no-important";
import { styles } from "./AccountStyles";
import { connect } from "react-redux";
import PopupWrapper from "../components/PopupWrapper";
import AccountSubheader from "../components/AccountSubheader";
import Spacer from "../components/Spacer";
import NewPassword from "../components/NewPassword";
import { Field, reduxForm, SubmissionError } from "redux-form";
import { passwordActions, popupActions } from "../_actions";
import { withCookies } from "react-cookie";
import AccountBackButton from "../components/AccountBackButton";

class AccountPassword extends Component {
  submitPassword = (values) => {
    this.props.dispatch(
      passwordActions.setPassword(values.password, values.newPassword)
    );
  };
  render() {
    return (
      <div className={css(styles.container)}>
        <PopupWrapper />

        <header className={css(styles.header)}>
          <div className={css(styles.titleWrapper)}>
            <img
              src={"/icons/AccountIconLarge.svg"}
              className={css(styles.accountIcon)}
              alt=""
            />
            <h1 className={css(styles.title)}>Account</h1>
          </div>
          <AccountBackButton />
        </header>
        <main className={css(styles.mainContainer)}>
          <AccountSubheader title="Password" />
          <NewPassword
            {...this.props.password}
            onSubmit={this.submitPassword}
          />
        </main>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    ...state,
  };
};

export default connect(mapStateToProps)(
  reduxForm({
    form: "accountPassword", // <------ same form name
    destroyOnUnmount: false, // <------ preserve form data
    enableReinitialize: true,
  })(withCookies(AccountPassword))
);
